<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Usage Record</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Usage Record</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
        <div class="container-fluid">
          <div class="card" id="UsageRecord">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
                <div class="card-tools">
                  <router-link class="btn btn-info" :to="{name: 'UsageRecordList'}"><i class="fas fa-list"></i> List
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                    <div class="col-8">


            <div class="form-group " >
              <label class="control-label">Subscription-Id</label>
              <input type="text" id="subscriptionId" name="subscriptionId"


                     v-model="value.subscriptionId" class="form-control subscriptionId"
                     placeholder="Subscription-Id">

            </div>
            <div class="form-group " >
              <label class="control-label">Expire At</label>
              <input type="text" id="expireDate" name="expireDate"


                     v-model="value.expireDate" class="form-control expireDate"
                     placeholder="Expire At">

            </div>
            <div class="form-group " >
              <label class="control-label">Reset Status</label>
              <select class="form-control" style="width: 100%;"
                       name="resetStatus" v-model="value.resetStatus" id="resetStatus">
                <option value="Void">Void</option><option value="Pending">Pending</option><option value="Halt">Halt</option>
              </select>

            </div>
            <div class="form-group " >
              <label class="control-label">Next Reset At</label>
              <input type="text" id="nextResetDate" name="nextResetDate"


                     v-model="value.nextResetDate" class="form-control nextResetDate"
                     placeholder="Next Reset At">

            </div>
            <div class="form-group required" >
              <label class="control-label">Usage Plan</label>
              <input type="text" id="usagePlanId" name="usagePlanId"
                     v-bind:class="{'has-error' : errors.has('usagePlanId')}"
                     v-validate="'required'"
                     v-model="value.usagePlanId" class="form-control usagePlanId"
                     placeholder="Usage Plan">
              <div class="help text-danger" v-show="errors.has('usagePlanId')">
                {{ errors.first("usagePlanId") }}
              </div>
            </div>
                    </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
                <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
              </div>
            </form>
          </div>
        </div>
    </section>
  </div>
</template>

<script>

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "UsageRecordForm",
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {


    },
    pre: {

    }
  }),
  methods: {
    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/usage";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/usage/" + _this.$route.params.id
            method = "PUT";
          }
          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.$router.push({"name": "UsageRecordList"});
          }).catch((errors) => {
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise(resolve => {
        let api_url = "/usage/" + id;
        let _this = this;
        axios.get(api_url)
          .then(response => {
            _this.value = response.data;
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id);
      }
      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  }
}
</script>

